export enum PricingUnitType {
    Stuk = 'Stuk',
    Kg = 'Kg',
    Liter = 'Liter',
    Doos = 'Doos',
    VierkanteMeter = 'm²',
}
